module.exports = __webpack_public_path__ + "static/media/Capture.3e92a84d.PNG";